// extracted by mini-css-extract-plugin
export default {"formCheckbox":"Checkbox_formCheckbox__uosBt"};